
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_Xf2JtTb3dAIHylW23tkdIL_MNUwTzKh_45rFjJvzP4fEMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/index.vue?macro=true";
import { default as contactFui4c16qGdPid0_45lzu8BnMPmg6vtIUpTXFqmQrbC9nMMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/contact.vue?macro=true";
import { default as doe_45mee0_45uzygQ3zIfHQLGjpFehunF8PtHKkNKFPAoAj4gv0hEMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/doe-mee.vue?macro=true";
import { default as donerenlAyGtqUqLPLC8PcVJbkBbsDeKEf7sHeYC6JjO_q72NAMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/doneren.vue?macro=true";
import { default as sandbox5bCAD37KcGJCT_454baimfK1_ee0_45iM73X1UztvVmNevwMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/sandbox.vue?macro=true";
import { default as indexxcIt9Po9EZdHZTQVzqAsp9eQGx_dTMuConFxt00bc_45kMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/tools/index.vue?macro=true";
import { default as indexiUb4R3Wl7tyaP_tLDzNNw4dBwO0M5k9E_45Pi_45mezag40Meta } from "/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/index.vue?macro=true";
import { default as indexvf7WweuZU5i8eWG8gellrW1T_qfWRnoh1Y1W_45N31HWIMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue?macro=true";
import { default as _91locationSlug_93lcDAYI_45MTqY27xQ81_45pt9uOnvbCgo1_IvrCe2YgjorsMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue?macro=true";
import { default as _91chapterName_93NiQYvV5gtmGxKFc9xi_zh4w6oWEvlZnuagk5K1cY8wkMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue?macro=true";
import { default as _91slug_93nco61zCJ5nGttI43fm7E_6chWM7_45MixTfj5ouTea_45iQMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug].vue?macro=true";
import { default as image_45fetcherIej4r0i7APJJj_45bYPIuUyPUvWz553FyInbjrVdjk0iYMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/tools/image-fetcher.vue?macro=true";
import { default as parse_45annotationsyeDYRnHZTLmdZ5s1Pq2y62d0YWVyV_45sneuL8_45saf8WkMeta } from "/home/tom/repros/ongehoord-ui-content/app/pages/tools/parse-annotations.vue?macro=true";
import { default as component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjsMeta } from "/home/tom/repros/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_26e18aab523b4a34be640f06c16325e7/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjs } from "/home/tom/repros/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_26e18aab523b4a34be640f06c16325e7/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___nl",
    path: "/",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/contact.vue")
  },
  {
    name: "doe-mee___nl",
    path: "/doe-mee",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/doe-mee.vue")
  },
  {
    name: "doe-mee___en",
    path: "/en/doe-mee",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/doe-mee.vue")
  },
  {
    name: "doneren___nl",
    path: "/doneren",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/doneren.vue")
  },
  {
    name: "doneren___en",
    path: "/en/doneren",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/doneren.vue")
  },
  {
    name: "sandbox___nl",
    path: "/sandbox",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/sandbox.vue")
  },
  {
    name: "sandbox___en",
    path: "/en/sandbox",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/sandbox.vue")
  },
  {
    name: "tools___nl",
    path: "/tools",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/index.vue")
  },
  {
    name: "tools___en",
    path: "/en/tools",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/index.vue")
  },
  {
    name: "onderzoek___nl",
    path: "/onderzoek",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/index.vue")
  },
  {
    name: "onderzoek___en",
    path: "/en/onderzoek",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/index.vue")
  },
  {
    name: _91slug_93nco61zCJ5nGttI43fm7E_6chWM7_45MixTfj5ouTea_45iQMeta?.name,
    path: "/onderzoek/:slug()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug].vue"),
    children: [
  {
    name: "onderzoek-slug___nl",
    path: "",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue")
  },
  {
    name: "onderzoek-slug-locaties-locationSlug___nl",
    path: "locaties/:locationSlug()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue")
  },
  {
    name: "onderzoek-slug-hoofdstukken-chapterName___nl",
    path: "hoofdstukken/:chapterName()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue")
  }
]
  },
  {
    name: _91slug_93nco61zCJ5nGttI43fm7E_6chWM7_45MixTfj5ouTea_45iQMeta?.name,
    path: "/en/onderzoek/:slug()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug].vue"),
    children: [
  {
    name: "onderzoek-slug___en",
    path: "",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue")
  },
  {
    name: "onderzoek-slug-locaties-locationSlug___en",
    path: "locaties/:locationSlug()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue")
  },
  {
    name: "onderzoek-slug-hoofdstukken-chapterName___en",
    path: "hoofdstukken/:chapterName()",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue")
  }
]
  },
  {
    name: "tools-image-fetcher___nl",
    path: "/tools/image-fetcher",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/image-fetcher.vue")
  },
  {
    name: "tools-image-fetcher___en",
    path: "/en/tools/image-fetcher",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/image-fetcher.vue")
  },
  {
    name: "tools-parse-annotations___nl",
    path: "/tools/parse-annotations",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/parse-annotations.vue")
  },
  {
    name: "tools-parse-annotations___en",
    path: "/en/tools/parse-annotations",
    component: () => import("/home/tom/repros/ongehoord-ui-content/app/pages/tools/parse-annotations.vue")
  },
  {
    name: component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjsMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjs
  },
  {
    name: component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjsMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubuvyAk_45NG5BG4SUtgvKywbGslQLh53zUzd3qwQ0MBjjs
  }
]